import Store from 'store/store';

const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	const acceptedCats = window.powCategories?.get() || [];
	if (!acceptedCats.includes('PERFORMANCE')) return;
	window.firePowsterCustomEvent(action, cat, label);
};

Store.on('TRACK_CALENDAR_BUTTON_CLICK', () => {
	fire('calendar-button-click', 'global', '');
});

Store.on('TRACK_HOME_DONATION_BUTTON_CLICK', () => {
	fire('donate-button-click', 'Home', '');
});

Store.on('TRACK_HOME_BG_VIDEO_PLAY_PERCENTAGE', ({ percentage }) => {
	fire('videos-watch', 'Home', `home_background_video_${percentage}`);
});

Store.on('TRACK_MUSIC_MUTED', ({ percentage }) => {
	fire('audio-click', 'global', `music_${percentage}`);
});

Store.on('TRACK_TILE_FULLY_IN_VIEW', ({ action, category, label }) => {
	fire(action, category, label);
});

Store.on('TRACK_STORE_TILE_CLICK', ({ action, category, label }) => {
	fire(action, category, label);
});

Store.on('TRACK_SHOP_DONATION_BUTTON_CLICK', ({ category }) => {
	fire('donate-button-click', 'donation', category);
});

Store.on('TRACK_VIDEO_PLAY_PERCENTAGE', ({ page, percentage, video }) => {
	fire('video-playback', page, `${video}_${percentage}`);
});

Store.on('TRACK_MODAL_CTA_CLICK', ({ type }) => {
	fire(`${type}-modal-click`, 'pop-up');
});

Store.on('TRACK_FOOTER_LINK_CLICK', ({ type, link }) => {
	fire(`${type}-link-click`, 'footer', link);
});
